<div class="checkbox-toggle"
     [ngClass]="{
                    'border-border-secondary': !isChecked && !disabled,
                    'border-primary-default bg-primary-default': isChecked && !disabled,
                    'border-primary-disabled': disabled,
                    'bg-primary-disabled': disabled || !isChecked
                 }"
     (click)="onCheckedHandle()">
    <div class="checkbox-toggle-ball"
         [ngClass]="{
            'ms-[12px] bg-white': isChecked,
            'ms-0 bg-neutral-800': !isChecked && !disabled,
            'ms-0 bg-border-secondary': !isChecked && disabled,
         }"></div>
</div>